<template lang="pug">
  include ./../../../mixins
  truncate.ds-caption--size_1xs.ds-caption--size_md-md.ds-caption--w_r.ds-caption--h_xs(
    class="read_more ds-caption ds-caption--c_blue ds-caption--h_sm-xl"
    :clamp='clamp',
    :length="width",
    :less="less",
    :text="text"
    type="html"
    )
</template>
<script>
import truncate from 'vue-truncate-collapsed';

export default {
  data() {
    return {
      width: '',
    }
  },
  components: {
    truncate,
  },
  props: {
    text: String,
    clamp: String,
    less: String,
    mobLength: String,
    DesctopLength: String,
  },
  created() {
    this.watchWidth()
  },
  methods: {
    watchWidth() {
      if (window.innerWidth >= 768) {
        if (!this.DesctopLength) {
          this.width = 1000
        } else {
          this.width = parseFloat(this.DesctopLength)
        }
      } else if (!this.mobLength) {
        this.width = 380
      } else {
        this.width = parseFloat(this.mobLength)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/app/UiElements/ReadMore.vue